module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"number":"Nummer","search":"Suche","subjects":"Module","title":"Bezeichnung"},"en":{"number":"Number","search":"Search","subjects":"Subjects","title":"Title"}}')
  delete Component.options._Ctor
}
